import React from "react";
import { Link } from "react-router-dom";
import { FaFacebookF, FaInstagram, FaLinkedinIn } from "react-icons/fa";
import logo from "../../assets/dhanvanti.png";

function Footer() {
  return (
    <footer className="site-footer">
      <div className="footer-inner">
        
        {/* Brand */}
        <img src={logo} alt="Dhanvanti Logo" style={{ height: "100px" }}/>

        {/* Navigation */}
        <nav className="footer-nav">
          <Link to="/">Home</Link>
          <Link to="/about">About</Link>
          <Link to="/leadership">Leadership</Link>
          <Link to="/contact">Contact Us</Link>
          <Link to="/blog">Blog</Link>
        </nav>

        {/* Social Icons */}
        <div className="footer-social">
          <a href="www.facebook.com"><FaFacebookF /></a>
          <a href="www.instagram.com"><FaInstagram /></a>
          <a href="www.linkedin.com"><FaLinkedinIn /></a>
        </div>

        {/* Divider */}
        <div className="footer-divider" />

        {/* Bottom */}
        <div className="footer-bottom">
          <p>
            © 2026 Made by Zebrians Creative Tribe. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;